import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/elements/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteHeader"] */ "/app/src/elements/header-client.tsx");
